<template>
    <div class="footer">
        <div class="footer-content">

            <div class="footer-top">
                <img class="footer-img" src="../assets/img/NTFusion_logo.png" alt="">
                <ul>
                    <li>
                        <a href="https://terrace.ntfusion.com/archive/cn/privacy-policy.html" target="_blank">隐私政策</a>
                    </li>
                    <li>
                        <a href="https://terrace.ntfusion.com/archive/cn/xieyi.html" target="_blank">用户协议</a>
                    </li>
                </ul>

            </div>


            <p class="fcm">{{langContent.footer_pc.info1}}</p>
            <p>{{langContent.footer_pc.info2}}</p>
            <p>
                <a href="http://beian.miit.gov.cn/" target="_blank">{{langContent.footer_pc.info3}}</a>
                |
                <a>{{langContent.footer_pc.info4}}</a>
                <br>
            </p>
            <p>{{langContent.footer_pc.info5}}</p>
            <!--<p>{{langContent.footer_pc.info6}}</p>-->
            <!--<p>{{langContent.footer_pc.info7}}</p>-->
        </div>
    </div>
</template>

<script>
    import langCn from '../data/lang_cn'
    // import langCn from '../data/lang_cn_sea'
    import langHant from '../data/lang_hant_sea'
    import langEn from '../data/lang_en_sea'
    import Utils from '../lib/utils'

    export default {
        data () {
            return {
                langContent: langCn,
                contents: '',
                langVal: 'cn'
            }
        },
        mounted() {
            let self = this;
            let lang = this.$route.query.lang?this.$route.query.lang:'';
            self.langVal = lang;

            if (lang == 'hant') {
                self.langContent = langHant;
            } else if (lang == 'cn') {
                self.langContent = langCn;
            } else if (lang == 'en') {
                self.langContent = langEn;
            }
        },
    }
</script>
<style lang="less">
    .footer {
        width: auto;
        padding: 40px 0;
        font-size: 13px;
        color: #ffffff;
        background-color: #282f3e;
        text-align: left;

        .footer-content {
            margin: 0 auto;
            width: 1000px;
            position: relative;

            .footer-top {
                overflow: unset!important;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;

                .footer-img {
                    width: 150px;
                    height: 50px;
                }
            }

            .fcm:before {
                display: block;
                margin: 18px 0 16px;
                height: 1px;
                content: "";
                background-color: rgba(83,97,128,.9);
            }

            ul {
                display: inline-block;
                li {
                    display: inline-block;
                    width: 60px;
                    height: 15px;
                    line-height: 15px;
                    a {
                        color: #0089bc;
                        text-decoration: underline;
                    }
                }
                li + li {
                    /*border-left: 2px solid #ffffff;*/
                }
            }
            p {
                margin: 10px 0 20px;

                a {
                    color: #ffffff;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue